var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColouredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    viewBox: "0 0 100 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coloured_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.6433 65.7963L98.6821 55.2263L100.002 51.8998L86.945 47.3926L83.4877 47.2578L64.6406 53.0927L64.6433 65.7963Z",
    fill: "url(#paint0_linear_766_41132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.3584 65.6615L1.31955 55.0916L0 51.7651L13.0567 47.2578H16.514L35.3624 53.0927L35.3584 65.6615Z",
    fill: "url(#paint1_linear_766_41132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.2934 0L39.5977 2.56497V67.5466H60.5353V2.56497L57.8396 0H42.2934Z",
    fill: "url(#paint2_linear_766_41132)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_766_41132",
    x1: 66.4555,
    y1: 64.8448,
    x2: 80.9611,
    y2: 37.1762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_766_41132",
    x1: 1.81491,
    y1: 64.7169,
    x2: 16.1548,
    y2: 37.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_766_41132",
    x1: 40.6722,
    y1: 64.0799,
    x2: 77.0183,
    y2: 52.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColouredIcon);
export default __webpack_public_path__ + "static/media/Coloured_Icon.457e7e45cebe77c606ca54c93bc41b25.svg";
export { ForwardRef as ReactComponent };